import React from 'react';
import { AGENDA_VIEW } from '../../hooks/useAgendaView';
import styles from './AgendaViewToggle.module.css';

const OPTIONS = [
  { value: AGENDA_VIEW.MINE, label: 'Minha agenda' },
  { value: AGENDA_VIEW.ALL, label: 'Todas' },
];

/** "Minha agenda / Todas" do Início (quem decide se aparece é useAgendaView). */
function AgendaViewToggle({ view, onChange }) {
  return (
    <div className={styles.toggle} role="radiogroup" aria-label="Agendas do Início">
      {OPTIONS.map((option) => (
        <button
          key={option.value}
          type="button"
          role="radio"
          aria-checked={view === option.value}
          className={`${styles.option} ${view === option.value ? styles.active : ''}`}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}

export default AgendaViewToggle;
